import { observeElement, getWidget } from '@uvocore-front/utils';
import '../../theme/DefaultTheme';

import '../../components/Header/main';
import '../../components/Footer';
import { templateListItem } from '../../components/Testimonial';

if (document.querySelector('[data-testimonials-widget-page]')) {
  observeElement({
    /* eslint-disable-line */
    element: '[data-testimonials-widget-page]',
    marginValue: 400,
    callback: () => {
      getWidget({
        /* eslint-disable-line */
        widgetLink: '/assets/js/testimonialsWidget.min.js',
        loader: false,
        fn: () => {
          window.tmWidget({
            params: {
              siteId: '55',
              limit: 10,
              maxBodyLength: 150,
            },
            callbackData: () => {
              const loader = document.querySelector('.Loader');
              if (loader) {
                document.querySelector('[data-testimonials-widget-page]').removeChild(loader);
              }
            },
            template: templateListItem,
            type: 'html',
            moreEl: '.load-more-testimonials',
            containerEl: '[data-testimonials-widget-page]',
          });
        },
      });
    },
  });
}
